import api from "api/axios";

// export const getArticles = (params) =>
//   api.get("/articles", { params });

export const getArticles = async ( params = {}) => {
  const response = await api.get(`/articles`, {
    params,
    signal: params.signal, // Pass AbortController signal if provided
  });
  return response.data;
};

export const getArticleById = (id) => api.get(`/articles/${id}`);

export const createArticle = (payload) => api.post("/articles", payload);

export const updateArticle = (id, payload) =>
  api.put(`/articles/${id}`, payload);

export const deleteArticle = (id) => api.delete(`/articles/${id}`);
